<template>
  <div>
    <component v-bind:is="getLayoutName" />
    <div class="vld-parent">
      <loading :active.sync="$store.state.isLoading"
               :can-cancel="true"
               :is-full-page="true"></loading>
    </div>
  </div>
</template>
<script>

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',

  components: {
    Loading
  },

  data: () => ({
  }),
  computed: {
    getLayoutName: function () {
      return (this.$route.meta.layout || 'base') + '-layout'
    }
  },
  created: function () {
    this.$store.dispatch('codeDef', {})
    this.$store.dispatch('setManualUrl')
  }
}
</script>

<style lang="scss">

.v-application{
  font-family: "Noto Sans JP", "Hiragino Kaku Gothic Pro", "メイリオ",
    sans-serif !important;
}

.logo {
  font-family: industry,serif;
  padding-top: 8px;
  font-weight: bold;
}

h1 {
  font-size: 1.75rem;
  border-bottom-color: #E62233;
  border-bottom-style: solid;
  border-bottom-width: 1.5px;
}

h2 {
  font-size: 1.0rem;
}

/* テキストフィールドのdisabled時の背景色 */
.v-input.v-text-field.v-input--is-disabled .v-input__control .v-input__slot {
  background-color:#EAEBEC;
}

.text-pre-wrap {
  white-space: pre-wrap;
}
</style>
